<template>
  <div id="initiaSelf" v-loading="loading" element-loading-text="拼命加载中">
    <h3>评价说明：</h3>

    <div class="instructions">
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;评分时，企业现状（结果）建议如下：</p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、较差：0—5分 企业未建有设备管理体系； 企业设备管理制度不能涵盖设备一生管理； 企业未建立设备管理评价指标； 企业设备管理处于事后维修状态；
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、一般：5—10分 企业设备管理体系不健全； 企业设备管理制度缺乏闭环管理，流于形式； 企业建立的设备经济运行指标不能有效促进企业设备管理；
        企业设备缺乏有效的预防性维护；
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3、良好：10—15分 企业有完整的设备管理体系及制度健全； 企业设备经济运行指标且能够指导企业设备管理的改进； 企业全面开展“5S”、“TPM”、管理；
        企业应用信息化设备管理平台，设备预防性维护基本形成闭环管理；
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4、较好：15—20分 企业在开展“5S”、“TPM”管理的基础上，全面推进精益管理； 企业已经形成以“自主保全”和“计划保全”体系；
        企业各项经济技术指标具备业内竞争实力； 企业已经实现关键设备的数字化、信息化管理； 企业预防性维护资金占总维修费用支出的70%以上；
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5、很好：20—25分 企业全面实现精益管理，经济效益业绩等在行业领先； 企业主要生产设备全面实现数字化、信息化管理；
        企业设备重复性故障发生率为“零”； 企业基本实现设备“零故障”;
      </p>
    </div>
    <h3>自我评价：</h3>
    <div class="selfBoxs">
      <initiaItem :isEdit="Boolean(isEdit)" style="padding-right: 10px; flex: 1" :data="examinationInfo"></initiaItem>
      <div class="catalogue">
        <h3 style="width: 100%; margin-bottom: 10px">目录</h3>
        <div v-for="(val, key, index) in formatCatalogue(catalogue)" :key="`${index}c`">
          <h4 style="color: #3d4859; font-size: 14px">{{ index + 1 }}、{{ key }}</h4>
          <div class="cataTitle">
            <div @click="handleCatalog(item)" :class="item.class" class="box nowrap" v-for="(item, index) in val" :key="`${index}a1`">{{ item.index }}{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="btnGurop">
      <el-button @click="common.returnBtn"><i class="el-icon-arrow-left"></i></el-button>
      <el-button v-if="!isEdit" :loading="btnLoading" type="primary" @click="successAve(2)">提 交</el-button>
      <el-button v-if="!isEdit" :loading="btnLoading" @click="successAve(1)">暂 存</el-button>
    </div>
    <FloatingButton @change="onBtnClicked">
      <span slot="text" class="green">
        <span style="font-weight: 600">{{ catalogue.filter((item) => item.class).length }}</span
        >/<span class="blue">{{ catalogue.length }}</span>
      </span>
    </FloatingButton>
    <el-drawer size="76%" title="目录" :visible.sync="drawer" direction="rtl">
      <div class="catalodfet">
        <div v-for="(val, key, index) in formatCatalogue(catalogue)" :key="`${index}c`">
          <h4 style="color: #3d4859; font-size: 14px">{{ index + 1 }}、{{ key }}</h4>
          <div class="cataTitle">
            <div @click="handleCatalog(item)" :class="item.class" class="box" v-for="(item, index) in val" :key="`${index}a1`">{{ item.index }}{{ item.name }}</div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment';
import initiaItem from './InitiaSelfItem/initia_Item.vue';
export default {
  name: 'initiaSelf',
  components: { initiaItem },
  data() {
    return {
      examinationInfo: [],
      bankId: this.$route.query.id, // 流程 id
      selfId: this.$route.query.selfId, // 自评 id
      isEdit: this.$route.query.isEdit || false, // 是否是查看
      loading: true,
      btnLoading: false,
      intervalId: null, // 自动保存
      catalogue: [],
      drawer: false,
      defaultExpansion: [], // 默认折叠展开的id
    };
  },
  watch: {
    examinationInfo: {
      handler(newVal, oldVal) {
        this.catalogue = [];
        this.filterByTier(newVal);
      },
      deep: true,
    },
  },
  created() {
    if (this.isEdit) {
      this.getExaminationInfo();
    } else {
      this.setBank().then((res) => {
        this.getExaminationInfo();
      });
    }
  },
  mounted() {
    let data = [
      { index: '1.1.1', firstLevelIndex: '1', firstLevelName: '组织保障模块' },
      { index: '1.2.1', firstLevelIndex: '1', firstLevelName: '组织保障模块' },
      { index: '1.2.3', firstLevelIndex: '1', firstLevelName: '组织保障模块' },
      { index: '2.1.1', firstLevelIndex: '2', firstLevelName: '三级建设' },
      { index: '2.2.1', firstLevelIndex: '2', firstLevelName: '三级建设' },
    ];
    let newData = {
      组织保障模块: [
        { index: '1.1.1', firstLevelIndex: '1', firstLevelName: '"组织保障模块"' },
        { index: '1.2.1', firstLevelIndex: '1', firstLevelName: '"组织保障模块"' },
        { index: '1.2.3', firstLevelIndex: '1', firstLevelName: '"组织保障模块"' },
      ],
      三级建设: [
        { index: '2.1.1', firstLevelIndex: '2', firstLevelName: '"三级建设"' },
        { index: '2.2.1', firstLevelIndex: '2', firstLevelName: '"三级建设"' },
      ],
    };
  },
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    moment,
    handleCatalog(item) {
      this.handDfaultFold(item.index);
      this.$nextTick(() => {
        let element = document.getElementById(`title${item.index}`);
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      });
    },
    // 同步自评评审细则
    setBank() {
      return new Promise((resolve, reject) => {
        this.$axios.post('api/selfAssessment/setBank', { id: this.bankId }).then((res) => {
          if (res.data.code == 200) {
            resolve(res);
          } else {
            this.$message({
              message: `评审细则获取失败${res.data.msg}`,
              type: 'error',
              offset: 80,
            });
            reject();
          }
        });
      });
    },
    // 获取详情回显内容
    getExaminationInfo() {
      this.$axios.post('api/selfAssessment/selfInfo', { selfId: this.selfId }).then((res) => {
        if (res.data.code == 200) {
          this.loading = false;
          this.examinationInfo = res.data.data;
          /**
           * 将 里面的 图片字符串转成数组
           */
          this.catalogue = [];
          this.filterByTier(this.examinationInfo);
          this.filterData(this.examinationInfo, true);
          this.recursionFun(res.data.data);
          if (this.isEdit) {
          } else {
            this.intervalId = setInterval(() => {
              console.log('🚀 ~ 自动保存中！！！:');
              if (this.$route.query.status == 1) {
                this.successAve(1, true);
              }
            }, 60000);
          }
        }
      });
    },
    // 提交和暂存
    successAve(status, save) {
      // 判断是暂存还是提交 1 是暂存 2 是提交
      if (status != 1) {
        const cataNum1 = this.catalogue.filter((item) => item.class).length;
        console.log('🚀 ~ 已答题数量:', cataNum1);
        console.log('🚀 ~ 总数量:', this.catalogue.length);
      }
      // 无论是暂存还是提交，都判读 状态 是不是待自评中，如果是待自评，正常走流程，否则都提示是否重新提交
      // this.$route.query.status 评审流程状态（1.企业待自评 2.专家待分配 3.专家评审中 4.已截止 5.已完成）
      if (this.$route.query.status != 1) {
        this.$confirm(`该评审已经提交，是否重复${status == 1 ? '暂存' : '提交'}？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.savePost(status, save);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            });
          });
      } else {
        this.savePost(status, save);
      }
    },
    savePost(status, save) {
      /**
       * copy 一份，避免影响原有数据
       * 将 里面的 图片数组转成字符串
       */
      this.btnLoading = true;
      let pandms = JSON.parse(JSON.stringify(this.examinationInfo));
      this.filterData(pandms, false);
      this.$axios.post(`api/selfAssessment/startSelfAssessmentList?status=${status}`, pandms).then((res) => {
        if (res.data.code == 200) {
          this.btnLoading = false;
          if (save) return;
          this.$message({
            message: `${status == 1 ? '暂存' : '提交'}成功`,
            type: 'success',
            offset: 80,
          });
          clearInterval(this.intervalId);
          this.common.returnBtn();
        } else {
          this.btnLoading = false;
          this.$message({
            message: `${status == 1 ? '暂存' : '提交'}失败${res.data.msg}`,
            type: 'error',
            offset: 80,
          });
        }
      });
    },
    onBtnClicked() {
      this.drawer = true;
    },
    filterData(data, type) {
      if (data && data.length) {
        try {
          data.forEach((e) => {
            if (type) {
              if (e.picture) {
                e.picture = e.picture.split(',');
              } else {
                e.picture = [];
              }
            } else {
              if (e.picture) {
                e.picture = e.picture.join(',');
              } else {
                e.picture = '';
              }
            }
            this.filterData(e.questionBankList, type);
          });
        } catch (error) {
          this.btnLoading = false;
          this.$message({
            message: `提交失败${res.data.msg}'`,
            type: 'error',
            offset: 80,
          });
        }
      }
    },
    // 格式化 目录数据
    formatCatalogue(data) {
      let newData = data.reduce((acc, item) => {
        if (!acc[item.firstLevelName]) {
          acc[item.firstLevelName] = [];
        }
        acc[item.firstLevelName].push(item);
        return acc;
      }, {});
      // console.log(`🚀 ~ newData:`, newData);
      return newData;
    },

    // 计算 序号
    filterByTier(data) {
      let that = this;
      function traverse(arr, parentIndex, firstLevelName, firstLevelIndex) {
        arr.forEach((obj, index) => {
          let currentIndex = '';
          currentIndex = parentIndex ? `${parentIndex}.${index + 1}` : `${index + 1}`;
          that.$set(obj, 'index', currentIndex);
          // 默认展开第一层
          if (obj.tier == 1) {
            that.defaultExpansion.push(obj.id);
            obj.firstLevelName = obj.name;
            obj.firstLevelIndex = currentIndex;
          } else {
            obj.firstLevelName = firstLevelName;
            obj.firstLevelIndex = firstLevelIndex;
          }
          if (obj.firstLevelName && obj.firstLevelName) {
            that.$set(obj, 'firstLevelNameIndex', `${obj.firstLevelIndex}.${obj.firstLevelName}`);
          }
          if (obj.tier == 3) {
            if (obj.testScore > 0) {
              that.$set(obj, 'class', 'complets');
            }
            that.catalogue.push(obj);
          }
          // console.log('🚀 ~ that.catalogue:', that.catalogue);
          if (obj.questionBankList) {
            traverse(obj.questionBankList, currentIndex, obj.firstLevelName, obj.firstLevelIndex);
          }
        });
      }
      traverse(data);
    },
    handDfaultFold(index) {
      diguiFold(this, this.examinationInfo);
      function diguiFold(that, arr) {
        if (arr && arr.length) {
          arr.forEach((e) => {
            that.$set(e, 'isFold', false);
            diguiFold(that, e.questionBankList);
          });
        }
      }
    },
    recursionFun(arr) {
      if (arr && arr.length) {
        arr.forEach((e) => {
          if (this.defaultExpansion.includes(e.id)) {
            this.$set(e, 'isFold', false);
          } else {
            this.$set(e, 'isFold', true);
          }
          this.$set(e, 'isEditRule', false);
          this.recursionFun(e.questionBankList);
        });
      }
    },
  },
  beforeDestroy() {
    // 清除定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
};
</script>

<style lang="less" scoped>
#initiaSelf {
  padding-bottom: 0 !important;
}
.btnGurop {
  display: flex;
  height: 50px;
  align-items: center;
}
.selfBoxs {
  height: calc(100% - 86px);
  display: flex;
  .catalogue {
    width: 280px;
    min-width: 280px;
    max-width: 280px;
    padding-left: 10px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    max-height: 85%;
    overflow-y: auto;
    overflow-x: hidden;
    .box {
      cursor: pointer;
      width: 85%;
      height: 30px;
      font-size: 14px;
      border: 1px solid #ccc;
      margin: 0 8px 8px 0;
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 0px 5px;
    }
    .complets {
      border: 1px solid #015d14;
      background-color: #198e3027;
    }
  }
}
.cataTitle {
  display: flex;
  flex-wrap: wrap;
  margin: 6px 0;
}
.catalodfet {
  padding-left: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .box {
    cursor: pointer;
    width: fit-content;
    height: 30px;
    font-size: 14px;
    border: 1px solid #ccc;
    margin: 0 8px 8px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 5px;
  }
  .complets {
    border: 1px solid #015d14;
    background-color: #198e3027;
  }
}
.instructions {
  line-height: 30px;
  margin-bottom: 20px;
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  .catalogue {
    display: none !important;
  }
}
</style>
